<ngb-datepicker
  #dp
  class="custom-datepicker px-2 pt-1 pb-3 w-100 border-0"
  navigation="none"
  [formControl]="dateControl"
  [minDate]="minDate | toNGBDate"
  [maxDate]="maxDate | toNGBDate"
  [footerTemplate]="footer"
  [startDate]="startDate | toNGBDate"
>
  <ng-template ngbDatepickerContent>
    @if (dp.state.firstDate; as firstMonth) {
    <div>
      <atx-date-picker-navigation
        (previous)="navigate(-1)"
        (next)="navigate(1)"
        (titleClick)="toggleCalendar()"
      >
        {{
          firstMonth.year + '-' + firstMonth.month + '-' + 1 | date: 'MMM yyyy'
        }}
      </atx-date-picker-navigation>
      <atx-month-picker
        [class.d-none]="!hideCalendar"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [month]="firstMonth.month"
        [year]="firstMonth.year"
        (monthSelect)="monthSelected($event)"
      ></atx-month-picker>
      <div class="d-flex">
        <ngb-datepicker-month
          [class.d-none]="hideCalendar"
          [month]="firstMonth"
        ></ngb-datepicker-month>
      </div>
      <div class="my-1">
        <ngb-timepicker
          [formControl]="timeControl"
          size="small"
          [meridian]="true"
        ></ngb-timepicker>
      </div>
    </div>
    }
  </ng-template>
</ngb-datepicker>

<ng-template #footer>
  <div class="d-flex justify-content-between">
    <button
      i18n="DateRange|Footer calendar cancel button@@cancelCalendarFooterBt"
      class="btn btn-light"
      (click)="canceled.emit()"
    >
      Cancel
    </button>
    <button
      i18n="DateRange|Footer calendar select button@@selectCalendarFooterBtn"
      class="btn btn-primary"
      (click)="selectedDate()"
    >
      Select
    </button>
  </div>
</ng-template>
